import { Bell, Menu, Moon, Search, Sun } from 'lucide-react'

import { Avatar, AvatarFallback, Button, Input } from '@/components/ui'
import { useSidebarStore, useThemeStore } from '@/stores'

export function Header() {
  const toggleMobile = useSidebarStore((s) => s.toggleMobile)
  const theme = useThemeStore((s) => s.theme)
  const toggleTheme = useThemeStore((s) => s.toggleTheme)
  const resolveTheme = useThemeStore((s) => s.resolveTheme)
  const isDark = (theme === 'system' ? resolveTheme() : theme) === 'dark'

  return (
    <header className="bg-card/80 border-border sticky top-0 z-30 flex h-[var(--header-height)] items-center gap-3 border-b px-4 backdrop-blur-md sm:px-6">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        onClick={toggleMobile}
        aria-label="Abrir menu"
      >
        <Menu className="h-5 w-5" />
      </Button>

      <div className="relative hidden max-w-md flex-1 md:block">
        <Search className="text-muted-foreground absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
        <Input
          className="bg-background/60 h-10 pl-9"
          placeholder="Buscar orçamentos, clientes, produtos..."
          aria-label="Busca global"
          readOnly
        />
      </div>

      <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
        <Button variant="ghost" size="icon" className="md:hidden" aria-label="Buscar">
          <Search className="h-4 w-4" />
        </Button>

        <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label="Alternar tema">
          {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>

        <Button variant="ghost" size="icon" aria-label="Notificações">
          <Bell className="h-4 w-4" />
        </Button>

        <Avatar className="ml-1 h-9 w-9 border border-border">
          <AvatarFallback>MI</AvatarFallback>
        </Avatar>
      </div>
    </header>
  )
}
